import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import LayersIcon from '@assets/icons/layersIcon';
import { Context } from "routes/private/Editor/Context";
import ToolTip from '@components/Tooltip';

const LayersTool: React.FC<IProps> = (props) => {
  let context = useContext(Context);
  
  const handleOpenLayersPanel = () => {  
    const picker = (context.editorStatus.currentPicker==="Layers")?undefined:"Layers";
    context.onShowPicker(picker);
  }
  
  return (
    <S.Root>
      <S.IconContainer
        onClick={handleOpenLayersPanel}
      >
        <ToolTip
          tip="Layers Panel"
          boxStyle={{
            top: `0px`,
            left: `30px`,
            right: `auto`,
            width: `140px`,
            justifyContent: `start`
          }}        
        >
          <LayersIcon
            style={{fillColor: (context.editorStatus.currentPicker==="Layers") ? C.WHITE : undefined}}
          />
        </ToolTip>
      </S.IconContainer>
    </S.Root>
  );
}

export default LayersTool;